import { ThumbnailBaseCommonType } from '@systemeio/digital-store-shared'
import { ThankYouPageErrorsType } from 'modules/stores/store/types/store-common-interface'
import {
  getThankYouErrorChecker,
  getThumbnailErrorChecker,
} from 'modules/stores/store/utils/get-error-checkers'
import { useFormErrorMessageInTabs } from 'modules/stores/store/utils/use-form-error-message-in-tabs'
import { OptinTabEnum, optinTabLocoKeys } from '../enum/optin-tab-enum'

export const useErrorMessageInTabs = () => {
  const { formErrorMessage: formErrorMessageCommon } = useFormErrorMessageInTabs()

  const getTabsWithErrors = ({
    errors,
  }: {
    errors: Omit<ThumbnailBaseCommonType, 'thumbnail'> & ThankYouPageErrorsType
  }): Record<OptinTabEnum, boolean> => {
    const hasThumbnailError = getThumbnailErrorChecker(errors)
    const hasThankYouError = getThankYouErrorChecker(errors)

    return {
      [OptinTabEnum.thumbnail]: hasThumbnailError,
      [OptinTabEnum.thankYou]: hasThankYouError,
      [OptinTabEnum.options]: false,
    }
  }

  const formErrorMessage = ({
    errors,
  }: {
    errors: Omit<ThumbnailBaseCommonType, 'thumbnail'> & ThankYouPageErrorsType
  }) => {
    const tabsErrorsMap = getTabsWithErrors({ errors })
    return formErrorMessageCommon({ tabsErrorsMap, tabsLocoKeys: optinTabLocoKeys })
  }

  return {
    getTabsWithErrors,
    formErrorMessage,
  }
}
